import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// import VueCarousel from '@jambonn/vue-carousel';
// Vue.use(VueCarousel);
// import Slick from 'vue-slick-carousel';
//
//
// import 'vue-slick-carousel/dist/vue-slick-carousel.css';
//
//
// Vue.component('Slick', Slick);

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
